<template>
  <div
    id="Compound"
    class="absolute top-30  left-0 bg-white overflow-hidden height-compound"
    style="z-index: 1000"
    :class="{ 'w-0': active, 'w-full': !active }"
  >
    <div ref="_container_items" class="px-1 md:px-3 overflow-x-hidden" :style="style">
      <div class="flex items-center sticky top-0 bg-white pt-3" style="z-index: 10000">
        <span :class="{ 'pl-3': !isStandard }">{{ question.label }}</span>
      </div>

      <div class="px-3 pb-3">
        <ItemList
          v-for="(_, i) in answersCompound"
          :key="i"
          v-model="answersCompound[i]"
          :activeCompound="active"
          @removeItem="removeItem(answersCompound[i], i)"
        ></ItemList>
      </div>
      <div class="px-3 pb-3 flex items-strech">
        <button
          @click="addIemQuestion"
          class="
            border-0
            bg-gray-100
            mr-3
            px-5
            rounded-lg
            flex
            items-center
            py-1
            pl-6
            cursor-pointer
            text-info
            font-bold
          "
        >
          <i class="material-icons p-0 m-0 bg-successf" style="font-size: 22px; line-height: 0.4"> add </i>
          <span>{{ text }}</span>
        </button>
        <span class="switch bg-gray-100 rounded-lg flex items-strech">
          <button
            @click="text = 'AND'"
            :class="text === 'AND' ? ['border-primary', 'text-white', 'bg-primary'] : ['text-disabled']"
            class="w-btn-switch p-0 m-0 rounded-l-lg border font-bold cursor-pointer py-2"
          >
            AND
          </button>
          <button
            @click="text = 'OR'"
            :class="text === 'OR' ? ['border-primary', 'text-white', 'bg-primary'] : ['text-disabled']"
            class="w-btn-switch p-0 m-0 rounded-r-lg border font-bold cursor-pointer text-light py-2"
          >
            OR
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ItemList from "./components/Items-list.vue";
import { dataCompound, formatAnswers, saveDependenceCompound, removeCompound } from "./compound";
export default {
  components: { ItemList },
  props: {
    active: {
      required: true,
      default: false,
      type: Boolean
    },
    father: {
      required: true,
      type: String
    },
    isStandard: {
      required: true,
      type: Boolean
    }
  },
  mounted() {
    const body = document.querySelector("body");
    body.style.overflow = "hidden";
    this.runDependencies();
    setTimeout(() => {
      const VModalPopup = document.querySelector(`#${this.father}  #VModel-customen`);
      this.style.width = `${VModalPopup.getBoundingClientRect().width}px`;
      this.style.height = `${VModalPopup.getBoundingClientRect().height - 65}px`;
    }, 100);
  },
  destroyed() {
    const body = document.querySelector("body");
    body.style.overflow = "auto";
    this.SaveCompound();
  },
  data() {
    return {
      counter: 1,
      text: "AND",
      style: {
        width: "200px",
        height: "200px",
        overflow: "auto"
      },
      answersCompound: []
    };
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage"]),
    /**
     * Obtiene la estructura json de la prgunta seleccionada
     */
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    existElement() {
      return this.answersCompound.find(question => question.name === "P_X");
    },
    reverseArray() {
      return [...this.answersCompound].reverse();
    }
  },
  watch: {
    isSmallerScreen(value) {
      const itemsQuestion = document.querySelector(`#${this.father}  #VModel-customen`);
      this.style.width = `${itemsQuestion.getBoundingClientRect().width}px`;
    },
    active(value) {
      if (value) this.SaveCompound();
    }
  },
  methods: {
    /**
     * Guarda la dependencia compuesta en el indexeDB
     */
    async SaveCompound() {
      saveDependenceCompound(this.question.name, this.answersCompound, this.text);
    },
    /**
     * Descincula a una de las preguntas de la dependencia compuesta.
     * @param { Object } question  - Es un objeto con las propiedades de la pregunta vinculada.
     * @param { Number } index - Posición de la pregunta cinculada dentro del array del formnulario.
     */
    async removeItem(question, index) {
      this.answersCompound.splice(index, 1);
      if (question.name !== "P_X") removeCompound(this.question.name, question.name);
    },
    /**
     * Extrae la lista de dependenica compuestas para la pregunta padre.
     */
    async runDependencies() {
      try {
        const result = await dataCompound(this.question.name);

        if (result) {
          const { answers, type } = result;
          this.text = type;
          const data = await formatAnswers(answers);
          this.answersCompound = data;
          this.answersCompound.push({
            name: "P_X",
            answers: null,
            type: "input",
            inputType: "default",
            label: "Seleccione una pregunta"
          });
        }
      } catch (error) {
        console.log("Error: runDependencies:", error);
      }
    },
    /**
     * Agrega las condiciones de cada pregunta a la lista de depedencias compuesta, las cuales afectaran a la pregunta padre.
     */
    async addIemQuestion() {
      const add = {
        name: "P_X",
        answers: null,
        type: "input",
        inputType: "default",
        label: "Seleccione una pregunta"
      };
      if (!this.existElement) {
        this.answersCompound.push(add);
        await this.SaveCompound();
        const div = this.$refs["_container_items"];
        div.scrollTop = div.scrollHeight;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#Compound {
  transition: width 0.5s;
}
.w-0 {
  width: -0%;
}

.bg-gray-100 {
  background-color: rgba(243, 244, 246, 1);
}

.text-info {
  color: blue;
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.w-btn-switch {
  width: 5em;
}

.text-disabled {
  color: #bdbdbd;
}

.height-compound {
  height: calc(100% - 40px);
}

.top-30 {
  top: 40px;
}
</style>
